import { useEffect, useState } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  queueOptionIds,
  withUnreadMessages,
  refreshKey,
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        try {
          const safeUpdatedAt =
            typeof updatedAt === "string" && !/^\d+$/.test(updatedAt.trim())
              ? updatedAt
              : undefined;

          const { data } = await api.get("/tickets", {
            params: {
              searchParam,
              pageNumber,
              tags,
              users,
              status,
              date,
              updatedAt: safeUpdatedAt,
              showAll,
              queueIds,
              queueOptionIds,
              withUnreadMessages,
            },
          });
          setTickets(Array.isArray(data?.tickets) ? data.tickets : []);
          setHasMore(Boolean(data?.hasMore));
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    tags,
    users,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    queueOptionIds,
    withUnreadMessages,
    refreshKey,
  ]);

  return { tickets, loading, hasMore };
};

export default useTickets;
